/*
* メニューコンポーネント
*/
<template>
	<div class="menus-component">
		<div v-if="burger" class="burger-area">
			<div class="burder-button" v-on:click.stop="showMenus">
				<icon name="bars" scale="1.5"></icon>
			</div>
			<div class="bg-area"></div>
		</div>
		<transition v-if="burger" name="burger_menu">
			<div v-if="burger" class="burger-menu-area" v-on:click.stop="">
				<div class="menu" v-for="(item, index) in menuItems">
					<router-link v-if="item.name != parentPage" :to="{ name: item.name, params: item.param }"><icon :name="item.icon" style="margin-right:6px"></icon>{{ item.title }}</router-link>
					<span v-else @click="hideMenus"><icon :name="item.icon" style="margin-right:6px"></icon>{{ item.title }}</span>
				</div>
			</div>
		</transition>
		<div v-if="!burger" class="menus">
			<span v-for="(item, index) in menuItems" class="menuitem">
				<router-link v-if="item.name != parentPage" :to="{ name: item.name, params: item.param }">{{ item.title }}</router-link>
				<span v-else>{{ item.title }}</span>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'menus',
	props: {
		burger: {},
		parentPage: {}
	},
	data() {
		return {
			menuItems: [
				{
					title: "トップ",
					name: "top-page",
					icon: "heart",
					param: {}
				},
				{
					title: "おしながき",
					name: "menu-page",
					icon: "book-open",
					param: {}
				},
				{
					title: "アルバム",
					name: "album-page",
					icon: "images",
					param: {}
				},
				{
					title: "ご予約",
					name: "reserve-page",
					icon: "phone",
					param: {}
				},
				{
					title: "アクセス他",
					name: "access-page",
					icon: "map-marked-alt",
					param: {}
				}
			]
		}
	},
	mounted() {
		let _self = this;
		this.menuItems = this.menuItems.filter(function(menu, i) {
			let r = true;
			let key = menu.name.split("-")[0];
			if ((key == "menu") || (key == "reserve") || (key == "album")) {
				if (!_self.$store.getters.enabledContents[key]) {
					r = false;
				}
			}
			return r;
		});
	},
	methods: {
		showMenus() {
			let bmnus = this.$el.querySelector(".burger-menu-area");
			bmnus.classList.add('burger-menu-active');
		},
		hideMenus() {
			let bmnus = this.$el.querySelector(".burger-menu-area");
			bmnus.classList.remove('burger-menu-active');
		}
	}
}
</script>

<style lang="less" scoped>
@import '../../less/reset.less';
@import '../../less/default.less';
@import '../../less/const.less';
.menus-component {
	z-index: 10;
}

.burger-area {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 999;
	display: none;
	
	.bg-area {
		position: absolute;
		width: 80px;
		height: 80px;
		top: -33px;
		left: -47px;
		border-radius: 50%;
		background-color: #000;
	}
	
	.burder-button {
		position: absolute;
		top: 6px;
		right: 8px;
		color: #fe83cc;
		z-index: 1000;
	}
}

.burger-menu-area {
	position: fixed;
	top: 0;
	right: -180px;
	bottom: 0;
	width: 180px;
	padding: 0 12px;
	background-color: #000;
	color: #ffe0e0;
	z-index: 1200;
	transition: all 300ms 0s ease;
	
	.menu {
		margin-top: 12px;
		font-size: 1.4rem;
	}
}

.burger-menu-active {
	right: 0px;
}

.menus {
	text-align: right;
	
	.menuitem {
		margin-left: 42px;
	}
}

.burger_menu-enter-active, .burger_menu-leave-active {
	transition: opacity 1s;
}
.burger_menu-enter, .burger_menu-leave-to {
	opacity: 0;
}

@media(max-width:826px) and (min-width: 420px){
	.burger-area {
		display: none;
	}
	
	.menus {
		.menuitem {
			margin-left: 18px;
		}
	}
}

@media(max-width:768px) and (min-width: 621px){
	.burger-area {
		display: none;
	}
	
	.menus {
		.menuitem {
			margin-left: 14px;
		}
	}
}

@media(max-width:825px) {
	.menus {
		.menuitem {
			margin-left: 24px;
		}
	}
}

@media(max-width:732px) {
	.burger-area {
		display: none;
	}
	
	.menus {
		.menuitem {
			margin-left: 18px;
		}
	}
}

@media(max-width:620px) {
	.burger-area {
		display: none;
	}
	
	.menus {
		display: none;
	}
}

@media(max-width:620px) and (max-height:390px) {
	.burger-area {
		display: none;
	}
	
	.menus {
		display: block;
		
		.menuitem {
			margin-left: 18px;
			font-size: 0.8rem;
		}
	}
}

@media(max-width:570px) and (max-height:340px) {
	.burger-area {
		display: none;
	}
	
	.menus {
		display: block;
		
		.menuitem {
			margin-left: 18px;
			font-size: 0.8rem;
		}
	}
}

@media(max-width:416px) {
	.burger-area {
		display: block;
	}
	
	.menus {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/template/menu.vue